export const mobAppPaymentResult = {
  name: 'MobAppPaymentResult',
  path: '/mob-payment-redirect',
  component: () =>
    import(
      /* webpackChunkName: "MobAppPaymentResult" */
      '@/views/mobappPaymentResult/Index.vue'
    ),
}
